/**
 * The widths the dashboard layout changes at, in pixels.
 *
 * One module so a breakpoint is a decision made once: JS that measures the
 * viewport and CSS that styles it read the same numbers. `SHELL_BREAKPOINT` is
 * mirrored in tailwind.config.js as the `shell` screen.
 */

// Phone width. Below it there is no room for a list beside a thread, or for a
// sidepanel beside either.
export const SMALL_SCREEN_BREAKPOINT = 768;

// The app shell turns two-column here: rail plus sidebar panel. Below it the
// sidebar is an off-canvas drawer and the mode toggle does not apply.
export const SHELL_BREAKPOINT = 992;

export const LARGE_SCREEN_BREAKPOINT = 1024;

// Measured on the conversation view, not the window - breakpoints can't see the
// app sidebar. Below this a 320px sidepanel has no room to open beside the list
// and the thread, so the rail that opens it would be a dead icon.
export const PANEL_RAIL_MIN_WIDTH = 1120;
